import { getDefaultTranslationKey, getTranslationOptions, getFilterFamilyName, legacyObjectTypes } from 'customer-data-filters-ui/utils/filterFamilyTranslation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import invariant from 'react-utils/invariant';
import memoize from 'transmute/memoize';
import partial from 'transmute/partial';
import I18n from 'I18n';
import { ObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { objectHasCustomLabels } from 'customer-data-filters-ui/utils/filterFamilyTranslationConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const LegacyFilterFamilyObjectNameTranslator = (filterFamily, isPlural = false) => {
  const legacyFilterFamily = getFilterFamilyName(filterFamily);
  invariant(legacyObjectTypes.includes(legacyFilterFamily), `Attempted to call FilterFamilyObjectNameTranslator with invalid filterFamily '${legacyFilterFamily}', it can only be used with legacy CrmObjects`);
  const pluralKey = isPlural ? 'plural' : 'singular';
  return I18n.text(`customerDataFiltersUI.customerDataFilters.LegacyFilterFamilyObjectNameTranslator.${legacyFilterFamily}.${pluralKey}`);
};
export const FilterFamilyObjectTypeIdTranslator = (filterFamily, isPlural = false) => {
  invariant(ObjectTypeIdRegex.test(filterFamily), `Attempted to call FilterFamilyObjectTypeIdTranslator with invalid filterFamily '${filterFamily}', it can only be used with object type ids`);
  invariant(objectHasCustomLabels(filterFamily), `Attempted to call FilterFamilyObjectTypeIdTranslator with filterFamily '${filterFamily}', but there is no entry in ObjectHasCustomLabels`);
  const pluralKey = isPlural ? 'plural' : 'singular';
  return I18n.text(`customerDataFiltersUI.customerDataFilters.FilterFamilyObjectTypeIdTranslator.${filterFamily}.${pluralKey}`);
};
const getTranslator = (prefix, filterFamily, getFilterFamilyEntityName = LegacyFilterFamilyObjectNameTranslator, getTranslationKey = getDefaultTranslationKey) => {
  const key = getTranslationKey(filterFamily);
  invariant(key, `translation key not found in ${prefix} for filterFamily '${filterFamily}'`);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `customerDataFiltersUI.customerDataFilters.${prefix}.${key}`,
    options: getTranslationOptions({
      filterFamily,
      getFilterFamilyEntityName
    })
  });
};
export const FilterFamilyAndButtonTooltipTranslator = memoize(partial(getTranslator, 'FilterFamilyAndButtonTooltipTranslator'));
export const FilterFamilyGroupHeadingTranslator = memoize(partial(getTranslator, 'FilterFamilyGroupHeadingTranslator'));
export const FilterFamilyNameTranslator = memoize(partial(getTranslator, 'FilterFamilyNameTranslator'));